import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const initialBehavioralObservations = {
  abortedExhale: { checked: false, comment: "" },
  assistingInhale: { checked: false, comment: "" },
  avoidanceTransitionTime: { checked: false, comment: "" },
  breathHolding: { checked: false, comment: "" },
  chestBreathing: { checked: false, comment: "" },
  doingBreathing: { checked: false, comment: "" },
  dysponesis: { checked: false, comment: "" },
  effortfulBreathing: { checked: false, comment: "" },
  forcedExhalation: { checked: false, comment: "" },
  gaspingSighing: { checked: false, comment: "" },
  intentionalManipulations: { checked: false, comment: "" },
  mouthBreathing: { checked: false, comment: "" },
  overbreathingPetCO2: { checked: false, comment: "" },
  rapidBreathing: { checked: false, comment: "" },
  reverseBreathing: { checked: false, comment: "" },
  takingDeepBreaths: { checked: false, comment: "" },
  underbreathing: { checked: false, comment: "" },
  otherBehavior: { checked: false, comment: "" }
};

const initialTriggers = {
  breathingMechanics: { checked: false, comment: "" },
  breathingSelfInterventions: { checked: false, comment: "" },
  conversationalContent: { checked: false, comment: "" },
  emotions: { checked: false, comment: "" },
  memories: { checked: false, comment: "" },
  physicalDiscomfort: { checked: false, comment: "" },
  posturalChanges: { checked: false, comment: "" },
  tasks: { checked: false, comment: "" },
  thoughts: { checked: false, comment: "" },
  otherTrigger: { checked: false, comment: "" },
};

const initialFearAnxiety = {
  allowingBreathing: { checked: false, comment: "" },
  approachingEndExhale: { checked: false, comment: "" },
  breathingInChest: { checked: false, comment: "" },
  breathingInDiaphragm: { checked: false, comment: "" },
  cantTakeDeepBreath: { checked: false, comment: "" },
  changesInBodySensations: { checked: false, comment: "" },
  fastBreathing: { checked: false, comment: "" },
  hypocapnicSymptoms: { checked: false, comment: "" },
  noseBreathing: { checked: false, comment: "" },
  slowBreathing: { checked: false, comment: "" },
  slownessOfExhale: { checked: false, comment: "" },
  smallBreaths: { checked: false, comment: "" },
  transitionTime: { checked: false, comment: "" },
  othersFear: { checked: false, comment: "" },
};

const initialThoughtsBeliefs = {
  breathingDone: { checked: false, comment: "" },
  disruptiveThoughts: { checked: false, comment: "" },
  fearOfBreathing: { checked: false, comment: "" },
  memories: { checked: false, comment: "" },
  selfTalk: { checked: false, comment: "" },
  symptomMisinterpretation: { checked: false, comment: "" },
};


const BreathingAssessmentForm = ({selectedFormId,data,selectedClientDetails}) => {
  const initialState = {
    clientName: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` :  "",
    clientEmail: "",
    date: "",
    referral: "",
    practitionerName: "",
    practitionerEmail: "",
    behavioralObservations: initialBehavioralObservations,
    triggers: initialTriggers,
    fearAnxiety: initialFearAnxiety,
    thoughtsBeliefs: initialThoughtsBeliefs,
    breathingChallenges: "",
    overbreathingPresent: "",
    baselinePetCO2: "",
    reportedSymptoms: "",
    recoveryTakePlace: "",
    recoveryWhyReason: "",
    returnToNormal: "",
    assistProcess: "",
    assistMethod: "",
    trappedInOverbreathing: "",
    clientExplanation: "",
    symptomsChangeWithBreathing: "",
    chestBreathing: "",
    suspectDysponesis: "",
    accessoryMuscles: "",
    emgPlacement1: "",
    emgPlacement2: "",
    breatheWithDiaphragm: "",
    preference: "",
    preferenceReason: "",
    triggeredMuscles: "",
    dysponesisDiaphragmShift: "",
    postureInfluence: "",
    postureInfluenceHow: "",
    emotionsThoughtsInfluence: "",
    correlation: "",
  };
  const { t } = useTranslation();
  const [formData, setFormData] = useState(data?data:initialState);

  // Generic text input/radio handler
  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "radio" ? value : value,
    }));
  };

  // Checkbox for nested categories
  const handleNestedCheckbox = (category, key) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: {
          ...prev[category][key],
          checked: e.target.checked,
        },
      },
    }));
  };

  // Comment for nested categories
  const handleNestedComment = (category, key) => (e) => {
    setFormData((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: {
          ...prev[category][key],
          comment: e.target.value,
        },
      },
    }));
  };

  // All radio for string fields
  const handleRadioChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit
 const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);
const handleSubmit = (e) => {
  e.preventDefault();
  
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);

  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
    session_id: localStorage.getItem("selectedSession") || null,
  };

  console.log("📤 Sending form payload test:", payload);

  fetch(API_URL + "/forms/trainer/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialState);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      setLoading(false);
    });
};

  // Helper: Render field group
  function renderFieldGroup(category, fields) {
    return (
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        <div style={{ width: "50%" }}>
          {fields.slice(0, Math.ceil(fields.length / 2)).map(({ key, label }) => (
            <div key={key} style={{ margin: "5px 0" }}>
              <input type="checkbox" id={key}
                checked={formData[category][key].checked}
                onChange={handleNestedCheckbox(category, key)}
              />
              <label htmlFor={key}>{label}</label>
              <input type="text"
                value={formData[category][key].comment}
                onChange={handleNestedComment(category, key)}
                style={commentInputStyle}
              />
            </div>
          ))}
        </div>
        <div style={{ width: "50%" }}>
          {fields.slice(Math.ceil(fields.length / 2)).map(({ key, label }) => (
            <div key={key} style={{ margin: "5px 0" }}>
              <input type="checkbox" id={key}
                checked={formData[category][key].checked}
                onChange={handleNestedCheckbox(category, key)}
              />
              <label htmlFor={key}>{label}</label>
              <input type="text"
                value={formData[category][key].comment}
                onChange={handleNestedComment(category, key)}
                style={commentInputStyle}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Field definitions
  const behavioralFields = [
    { key: "abortedExhale", label: "Aborted exhale" },
    { key: "assistingInhale", label: "Assisting the inhale" },
    { key: "avoidanceTransitionTime", label: "Avoidance of transition time" },
    { key: "breathHolding", label: "Breath holding" },
    { key: "chestBreathing", label: "Chest breathing" },
    { key: "doingBreathing", label: "Doing breathing (not allowing)" },
    { key: "dysponesis", label: "Dysponesis (muscles)" },
    { key: "effortfulBreathing", label: "Effortful breathing" },
    { key: "forcedExhalation", label: "Forced exhalation" },
    { key: "gaspingSighing", label: "Gasping, sighing" },
    { key: "intentionalManipulations", label: "Intentional manipulations" },
    { key: "mouthBreathing", label: "Mouth breathing" },
    { key: "overbreathingPetCO2", label: "Overbreathing (PetCO₂ levels)" },
    { key: "rapidBreathing", label: "Rapid breathing (Rate range)" },
    { key: "reverseBreathing", label: "Reverse breathing" },
    { key: "takingDeepBreaths", label: "Taking deep breaths" },
    { key: "underbreathing", label: "Underbreathing" },
    { key: "otherBehavior", label: "Other" }
  ];
  const triggersFields = [
    { key: "breathingMechanics", label: "Breathing mechanics" },
    { key: "breathingSelfInterventions", label: "Breathing self interventions" },
    { key: "conversationalContent", label: "Conversational content" },
    { key: "emotions", label: "Emotions" },
    { key: "memories", label: "Memories" },
    { key: "physicalDiscomfort", label: "Physical discomfort" },
    { key: "posturalChanges", label: "Postural (kinesthetic) changes" },
    { key: "tasks", label: "Tasks" },
    { key: "thoughts", label: "Thoughts" },
    { key: "otherTrigger", label: "Other" },
  ];
  const fearFields = [
    { key: "allowingBreathing", label: "Allowing the breathing" },
    { key: "approachingEndExhale", label: "Approaching the end of the exhale" },
    { key: "breathingInChest", label: "Breathing in the chest" },
    { key: "breathingInDiaphragm", label: "Breathing in the diaphragm" },
    { key: "cantTakeDeepBreath", label: "Can't take a deep breath" },
    { key: "changesInBodySensations", label: "Changes in body sensations" },
    { key: "fastBreathing", label: "Fast breathing" },
    { key: "hypocapnicSymptoms", label: "Hypocapnic symptoms" },
    { key: "noseBreathing", label: "Nose breathing" },
    { key: "slowBreathing", label: "Slow breathing" },
    { key: "slownessOfExhale", label: "Slowness of the exhale" },
    { key: "smallBreaths", label: "Small breaths" },
    { key: "transitionTime", label: "Transition time (exhale to inhale)" },
    { key: "othersFear", label: "Others" },
  ];
  const thoughtsFields = [
    { key: "breathingDone", label: 'Breathing is "done" (not allowed)' },
    { key: "disruptiveThoughts", label: "Disruptive thoughts" },
    { key: "fearOfBreathing", label: "Faulty beliefs" },
    { key: "memories", label: "Memories" },
    { key: "selfTalk", label: "Self-talk" },
    { key: "symptomMisinterpretation", label: "Symptom misinterpretation" },
  ];

  return (
    <div style={{
      fontFamily: "Arial, sans-serif",
      maxWidth: "1200px",
      margin: "20px auto",
      padding: !data?"15px":"10px",
      border: !data && "1px solid #ccc",
      marginTop: "20px"
    }}>
      <h1 style={{ color: "#cc0000", textAlign: "center", fontSize: "24px", fontWeight: "bold", marginBottom: "15px" }}>
        SCREENING REPORT
      </h1>
      {/* Client Information */}
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "15px" }}>
        <div style={{ flex: "1" }}>
          <span>Client Name: </span>
          <input type="text" disabled={Boolean(selectedClientDetails)} name="clientName" value={formData.clientName} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ flex: "1" }}>
          <span>Email: </span>
          <input type="text" name="clientEmail" value={formData.clientEmail} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ flex: "1" }}>
          <span>Date: </span>
          <input type="text" name="date" value={formData.date} onChange={handleInputChange} style={inputStyle} />
        </div>
      </div>
      {/* Referral */}
      <div style={{ marginBottom: "15px" }}>
        <span style={{ color: "#cc0000", fontWeight: "bold" }}>REFERRAL? </span>
        <input type="radio" id="referralYes" name="referral" value="yes" checked={formData.referral === "yes"} onChange={handleInputChange} />
        <label htmlFor="referralYes" style={{ marginRight: "15px" }}> Yes </label>
        <input type="radio" id="referralNo" name="referral" value="no" checked={formData.referral === "no"} onChange={handleInputChange} />
        <label htmlFor="referralNo" style={{ marginRight: "15px" }}> No </label>
        <span>Practitioner Name </span>
        <input type="text" name="practitionerName" value={formData.practitionerName} onChange={handleInputChange} style={inputStyle} />
        <span>Email: </span>
        <input type="text" name="practitionerEmail" value={formData.practitionerEmail} onChange={handleInputChange} style={inputStyle} />
      </div>
      {/* Behavioral Observations */}
      <div style={{ marginBottom: "15px" }}>
        <div style={{ fontWeight: "bold", color: "#cc0000" }}>
          BEHAVIORAL OBSERVATIONS:<span style={{ color: "black" }}> Dysfunctional breathing behaviors</span>
        </div>
        {renderFieldGroup("behavioralObservations", behavioralFields)}
      </div>
      {/* Triggers */}
      <div style={{ marginBottom: "15px" }}>
        <div style={{ fontWeight: "bold" }}>Triggers of dysfunctional breathing DURING the interview:</div>
        {renderFieldGroup("triggers", triggersFields)}
      </div>
      {/* Fear or Anxiety */}
      <div style={{ marginBottom: "15px" }}>
        <div style={{ fontWeight: "bold" }}>Fear or anxiety associated with breathing:</div>
        {renderFieldGroup("fearAnxiety", fearFields)}
      </div>
      {/* Thoughts and beliefs */}
      <div style={{ marginBottom: "15px" }}>
        <div style={{ fontWeight: "bold" }}>Thoughts and beliefs associated with breathing:</div>
        {renderFieldGroup("thoughtsBeliefs", thoughtsFields)}
      </div>
      {/* Breathing challenges outcome */}
      <div style={{ marginBottom: "15px", display: "flex", marginTop: "15px" }}>
        <label style={{ fontWeight: "bold" }}>Breathing challenges used and outcomes: </label>
        <input type="text" name="breathingChallenges" value={formData.breathingChallenges} onChange={handleInputChange} style={inputStyle} />
      </div>
      {/* CAPNOGRAPHY (PetCO2): */}
      <div style={{ marginBottom: "20px" }}>
        <div style={{ fontWeight: "bold", color: "#cc0000", marginBottom: "5px" }}>
          <span>CAPNOGRAPHY (PetCO₂):</span> Was overbreathing (below 35 mmHg) present at the start of the session?
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="overbreathingYes" name="overbreathingPresent" value="yes" checked={formData.overbreathingPresent === "yes"} onChange={() => handleRadioChange("overbreathingPresent", "yes")} />
            <label htmlFor="overbreathingYes"> Yes </label>
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="overbreathingNo" name="overbreathingPresent" value="no" checked={formData.overbreathingPresent === "no"} onChange={() => handleRadioChange("overbreathingPresent", "no")} />
            <label htmlFor="overbreathingNo"> No </label>
          </span>
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>What were the initial baseline PetCO₂ values (first two minutes)? </label>
          <input type="text" name="baselinePetCO2" value={formData.baselinePetCO2} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>What symptoms/deficits were reported, if any? </label>
          <input type="text" name="reportedSymptoms" value={formData.reportedSymptoms} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex", alignItems: "center" }}>
          <label>If so, did recovery take place on its own within a few minutes? </label>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="recoveryYes" name="recoveryTakePlace" value="yes" checked={formData.recoveryTakePlace === "yes"} onChange={() => handleRadioChange("recoveryTakePlace", "yes")} />
            <label htmlFor="recoveryYes"> Yes </label>
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="recoveryNo" name="recoveryTakePlace" value="no" checked={formData.recoveryTakePlace === "no"} onChange={() => handleRadioChange("recoveryTakePlace", "no")} />
            <label htmlFor="recoveryNo"> No </label>
          </span>
          <label style={{ marginLeft: "10px" }}>Why? </label>
          <input type="text" name="recoveryWhyReason" value={formData.recoveryWhyReason} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>If not, when did PetCO₂ levels return to normal, and why? </label>
          <input type="text" name="returnToNormal" value={formData.returnToNormal} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex", alignItems: "center" }}>
          <label>Did you assist in this process? </label>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="assistYes" name="assistProcess" value="yes" checked={formData.assistProcess === "yes"} onChange={() => handleRadioChange("assistProcess", "yes")} />
            <label htmlFor="assistYes"> Yes </label>
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="assistNo" name="assistProcess" value="no" checked={formData.assistProcess === "no"} onChange={() => handleRadioChange("assistProcess", "no")} />
            <label htmlFor="assistNo"> No </label>
          </span>
          <label style={{ marginLeft: "10px" }}>How did you assist? </label>
          <input type="text" name="assistMethod" value={formData.assistMethod} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex", alignItems: "center" }}>
          <label>Was your client trapped in overbreathing? </label>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="trappedYes" name="trappedInOverbreathing" value="yes" checked={formData.trappedInOverbreathing === "yes"} onChange={() => handleRadioChange("trappedInOverbreathing", "yes")} />
            <label htmlFor="trappedYes"> Yes </label>
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="trappedNo" name="trappedInOverbreathing" value="no" checked={formData.trappedInOverbreathing === "no"} onChange={() => handleRadioChange("trappedInOverbreathing", "no")} />
            <label htmlFor="trappedNo"> No </label>
          </span>
        </div>
        <div style={{ margin: "5px 0" }}>
          <label>What was your client's explanation for the associated symptoms? </label>
          <input type="text" name="clientExplanation" value={formData.clientExplanation} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0" }}>
          <label>How did the symptoms/deficits change as breathing changed? </label>
          <input type="text" name="symptomsChangeWithBreathing" value={formData.symptomsChangeWithBreathing} onChange={handleInputChange} style={inputStyle} />
        </div>
      </div>
      {/* EMG Section */}
      <div style={{ marginBottom: "20px" }}>
        <div style={{ fontWeight: "bold", color: "#cc0000", marginBottom: "5px", display: "flex", alignItems: "center" }}>
          <span>
            EMG: Was your client "chest breathing" at the start of the session?"
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="chestBreathingYes" name="chestBreathing" value="yes" checked={formData.chestBreathing === "yes"} onChange={() => handleRadioChange("chestBreathing", "yes")} />
            <label htmlFor="chestBreathingYes"> Yes </label>
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="chestBreathingNo" name="chestBreathing" value="no" checked={formData.chestBreathing === "no"} onChange={() => handleRadioChange("chestBreathing", "no")} />
            <label htmlFor="chestBreathingNo"> No </label>
          </span>
          <span style={{ marginLeft: "15px" }}>
            Do you suspect dysponesis?
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="dysponesisYes" name="suspectDysponesis" value="yes" checked={formData.suspectDysponesis === "yes"} onChange={() => handleRadioChange("suspectDysponesis", "yes")} />
            <label htmlFor="dysponesisYes"> Yes </label>
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="dysponesisNo" name="suspectDysponesis" value="no" checked={formData.suspectDysponesis === "no"} onChange={() => handleRadioChange("suspectDysponesis", "no")} />
            <label htmlFor="dysponesisNo"> No </label>
          </span>
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>If so, what breathing accessory muscles were being used? </label>
          <input type="text" name="accessoryMuscles" value={formData.accessoryMuscles} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>What EMG placement did you make and what were the readings? </label>
          <input type="text" name="emgPlacement1" value={formData.emgPlacement1} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          <div style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
            <label>Did you ask your client to breathe with the diaphragm? If so, could (s)he do so? </label>
            <span style={{ display: "inline-block", marginLeft: "10px" }}>
              <input type="radio" id="diaphragmYes" name="breatheWithDiaphragm" value="yes" checked={formData.breatheWithDiaphragm === "yes"} onChange={() => handleRadioChange("breatheWithDiaphragm", "yes")} />
              <label htmlFor="diaphragmYes"> Yes </label>
            </span>
            <span style={{ display: "inline-block", marginLeft: "10px" }}>
              <input type="radio" id="diaphragmNo" name="breatheWithDiaphragm" value="no" checked={formData.breatheWithDiaphragm === "no"} onChange={() => handleRadioChange("breatheWithDiaphragm", "no")} />
              <label htmlFor="diaphragmNo"> No </label>
            </span>
            <span style={{ display: "inline-block", marginLeft: "10px" }}>
              <input type="radio" id="diaphragmNA" name="breatheWithDiaphragm" value="na" checked={formData.breatheWithDiaphragm === "na"} onChange={() => handleRadioChange("breatheWithDiaphragm", "na")} />
              <label htmlFor="diaphragmNA"> N/A </label>
            </span>
          </div>
        </div>
        <div style={{ margin: "5px 0", display: "flex", alignItems: "center" }}>
          <label>If so, which did they prefer </label>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="preferChest" name="preference" value="chest" checked={formData.preference === "chest"} onChange={() => handleRadioChange("preference", "chest")} />
            <label htmlFor="preferChest"> chest </label>
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="preferDiaphragm" name="preference" value="diaphragm" checked={formData.preference === "diaphragm"} onChange={() => handleRadioChange("preference", "diaphragm")} />
            <label htmlFor="preferDiaphragm"> diaphragm</label>
          </span>
          <span style={{ marginLeft: "10px" }}>? What was the preference based on? </span>
          <input type="text" name="preferenceReason" value={formData.preferenceReason} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>What muscles unrelated to breathing were triggered by breathing (e.g., jaw)? </label>
          <input type="text" name="triggeredMuscles" value={formData.triggeredMuscles} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>What EMG placement did you make and what were the readings? </label>
          <input type="text" name="emgPlacement2" value={formData.emgPlacement2} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>How was dysponesis affected when (and if) your client shifted into the diaphragm? </label>
          <input type="text" name="dysponesisDiaphragmShift" value={formData.dysponesisDiaphragmShift} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex", alignItems: "center" }}>
          <label>Did posture influence breathing? </label>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="postureYes" name="postureInfluence" value="yes" checked={formData.postureInfluence === "yes"} onChange={() => handleRadioChange("postureInfluence", "yes")} />
            <label htmlFor="postureYes"> Yes </label>
          </span>
          <span style={{ display: "inline-block", marginLeft: "10px" }}>
            <input type="radio" id="postureNo" name="postureInfluence" value="no" checked={formData.postureInfluence === "no"} onChange={() => handleRadioChange("postureInfluence", "no")} />
            <label htmlFor="postureNo"> No </label>
          </span>
          <label style={{ marginLeft: "10px" }}>If so, how? </label>
          <input type="text" name="postureInfluenceHow" value={formData.postureInfluenceHow} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>How did emotions and thoughts shift muscle utilization? </label>
          <input type="text" name="emotionsThoughtsInfluence" value={formData.emotionsThoughtsInfluence} onChange={handleInputChange} style={inputStyle} />
        </div>
        <div style={{ margin: "5px 0", display: "flex" }}>
          <label>What correlation did you observe among EMG, PetCO₂, and breathing rate? </label>
          <input type="text" name="correlation" value={formData.correlation} onChange={handleInputChange} style={inputStyle} />
        </div>
      </div>
  {!data &&  <div className="client-submit-btn">
        <button type="submit" onClick={handleSubmit}>
          {loading?t("Submitting..."):t("Submit")}
        </button>
      </div>}
       <Modal
                                                                    isOpen={successModal}
                                                                    toggle={successToggleModal}
                                                                    className="connect-box"
                                                                    centered={true}
                                                                  >
                                                                    <ModalHeader toggle={successToggleModal}>
                                                                      <span className="ml-1 roititle font-weight-bold">
                                                                        Successfull
                                                                      </span>
                                                                    </ModalHeader>
                                                                    <ModalBody>
                                                                      <div className="modal-p">
                                                                        <p>Trainer form has been submitted successfully.</p>
                                                                      </div>
                                                                    </ModalBody>
                                                                  </Modal>
    </div>
  );
};

const inputStyle = {
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
  borderBottom: "1px solid black",
  backgroundColor: "#f1f4ff",
  height: "30px",
  outline: "none",
  marginLeft: "10px",
  minWidth: "150px",
};
const commentInputStyle = {
  borderTop: "none",
  borderLeft: "none",
  borderRight: "none",
  borderBottom: "1px solid black",
  backgroundColor: "#f1f4ff",
  height: "30px",
  outline: "none",
  marginLeft: "5px",
  width: "40%"
};

export default BreathingAssessmentForm;
